module.exports = __webpack_public_path__ + "static/media/pe.ea95116f.svg";